import { CalendarCheck, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

interface AvailabilityBadgeProps {
  variant?: 'hero' | 'standalone';
  className?: string;
}

export function AvailabilityBadge({ variant = 'hero', className = '' }: AvailabilityBadgeProps) {
  // Get current month + 1 for "now booking" messaging
  const getBookingMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };

  if (variant === 'hero') {
    return (
      <div className={`flex flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap ${className}`}>
        {/* Location Badge */}
        <div className="ethereal-badge w-full max-w-[22rem] text-center sm:w-auto sm:text-left">
          <MapPin className="h-4 w-4 text-primary" />
          <span className="text-sm leading-relaxed text-foreground/92">Based in Wayne, OK • Available Worldwide</span>
        </div>
        
        {/* Availability Badge */}
        <Link 
          to="/booking"
          className="ethereal-badge w-full max-w-[22rem] text-center sm:w-auto group border-primary/35 bg-primary/12 text-foreground hover:bg-primary/18"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary/60 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
          </span>
          <CalendarCheck className="h-4 w-4 text-primary" />
          <span className="text-sm font-semibold leading-relaxed text-foreground/96">
            Now Booking {getBookingMonth()}
          </span>
        </Link>
      </div>
    );
  }

  return (
    <Link 
      to="/booking"
      className={`ethereal-panel inline-flex items-center gap-3 px-6 py-3 hover:border-primary/60 transition-colors group ${className}`}
    >
      <span className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary/60 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-primary"></span>
      </span>
      <div>
        <p className="text-sm font-medium text-foreground">Limited Availability</p>
        <p className="text-xs text-muted-foreground">Now booking {getBookingMonth()}</p>
      </div>
      <CalendarCheck className="h-5 w-5 text-primary group-hover:scale-110 transition-transform" />
    </Link>
  );
}
